export enum CtrlColorScheme {
  ERROR = 'error',
  DEFAULT = 'default',
  HINT = 'hint',
  INFO = 'info',
  WARNING = 'warning'
}
